import { useEffect, useState } from 'react';
import AccordianDownIcon from '../../assets/AccordianDownIcon';
import AccordianDownIconDark from '../../assets/AccordianDownIconDark';
import AccordianUpIcon from '../../assets/AccordianUpIcon';
import AccordianUpIconDark from '../../assets/AccordianUpIconDark';
import Accordion from '../../components/common/Accordian';
import useBgColorStore from '../../store/bgColor';
import BallIcon from '../../assets/BallIcon';
import Loader from '../../assets/loader/Loader';
import { IOperationCheckList } from '../../type/operationCheckList';
import EditIcon from '../../assets/EditIcon';
import BookingDetailsCard from './BookingDetails';
import BallIconDark from '../../assets/BallIconDark';
import { translate } from '../../i18n';
import { encodeDateForUrl, getAdjustedDate } from '../../utils/dateUtils';
import useLocationStore from '../../store/locatonStore';
import useDateStore from '../../store/selectedDateStore';
import EditIconDark from '../../assets/EditIconDark';
import { useOperationChecklist } from '../../hooks/apiHook/operationDetails';
interface IOperationCheckListProps {
  date?: Date;
}
export default function OperationCheckListComponent(
  props: IOperationCheckListProps,
) {
  const [editingBookingId, setEditingBookingId] = useState<number | null>(null);
  const [isAccordionClosed] = useState(false);
  const { bgColor } = useBgColorStore();
  const handleEditClick = (bookingId: number | null) => {
    if (bookingId === null) {
      setEditingBookingId(null);
    } else {
      setEditingBookingId(bookingId);
    }
  };

  const [reloadKey, setReloadKey] = useState(0);
  const handleStaffChange = (type: 'driver' | 'pilot' | 'crew' | 'booking') => {
    if ((type = 'booking')) {
      setReloadKey((prevKey) => prevKey + 1);
      setBookingAccordionIsOpen(true);
      refetchOperationChecklist();
    }
  };

  const handleEditEnd = () => {
    setEditingBookingId(null);
  };
  const [operationCheckList, setOperationCheckList] =
    useState<IOperationCheckList[]>();

  const { selectedDateFromStore, setSelectedDateFromStore } = useDateStore();
  const [bookingAccordionIsOpen, setBookingAccordionIsOpen] = useState<
    boolean | undefined
  >(false);
  const selectedLocation = useLocationStore((state) => state.selectedLocation);

  const [selectedDate] = useState<Date>(
    selectedDateFromStore || getAdjustedDate()||props.date,
  );
  const encodedDate = encodeDateForUrl(props.date || new Date());

  const {
    data: checklistData,
    isLoading: isChecklistLoading,
    isFetching: isChecklistFetching,
    refetch: refetchOperationChecklist,
  } = useOperationChecklist(selectedLocation?.OwnerId ?? null, encodedDate);

  // Set the state when data is fetched
  useEffect(() => {
    if (checklistData) {
      setOperationCheckList(checklistData);
    }
  }, [checklistData]);


  return (
    <>
      <div className={`${bgColor} mt-2`}>
        <Accordion
          title="Operation Check List"
          // bgColor={bgColor}
          iconOpen={
            <div>
              <div className="block dark:hidden">
                <AccordianDownIcon />
              </div>
              <div className="hidden dark:block">
                <AccordianDownIconDark />
              </div>
            </div>
          }
          iconClose={
            <div>
              <div className="block dark:hidden">
                <AccordianUpIcon />
              </div>
              <div className="hidden dark:block">
                <AccordianUpIconDark />
              </div>
            </div>
          }
          onToggleEditMode={handleEditClick}
          accordionIsOpen={bookingAccordionIsOpen}
          toggleState={setBookingAccordionIsOpen}
          icon={
            operationCheckList && operationCheckList.length > 0 ? (
              <div>
                <div className="block dark:hidden">
                  <BallIcon />
                </div>
                <div className="hidden dark:block">
                  <BallIconDark />
                </div>
              </div>
            ) : undefined
          }
        >
          {isChecklistLoading || isChecklistFetching ? (
            <div className="flex justify-center align-middle">
              <Loader />
            </div>
          ) : operationCheckList && operationCheckList.length > 0 ? (
            operationCheckList?.map(
              (details: IOperationCheckList, index: number) => (
                <Accordion
                  key={index}
                  title={details.bookingName || 'No Title'}
                  icon={
                    <div>
                      <div className="block dark:hidden">
                        <EditIcon
                          onClick={() => handleEditClick(details.bookingId)}
                          style={{ cursor: 'pointer' }}
                        />
                      </div>
                      <div className="hidden dark:block">
                        <EditIconDark
                          onClick={() => handleEditClick(details.bookingId)}
                          style={{ cursor: 'pointer' }}
                        />
                      </div>
                    </div>
                  }
                  bgColor={`bg-backgroundColor-darkThemeColor`}
                  status={details?.status}
                  onToggleEditMode={handleEditClick}
                >
                  <BookingDetailsCard
                    details={details}
                    isEditing={editingBookingId === details.bookingId}
                    onEditEnd={handleEditEnd}
                    onStaffChange={() => handleStaffChange('booking')}
                    isAccordionClosed={isAccordionClosed}
                  />
                </Accordion>
              ),
            )
          ) : (
            <div className="text-center text-textColorGray p-4">
              {translate('operation.dataIsNotAvailable')}
            </div>
          )}
        </Accordion>
      </div>
      <div className="pt-3"></div>
    </>
  );
}
